import { marketplaceData } from 'helpers'


// mc   - молодежный центр
// ikar - икар
// ip   - ледовый дворец
const getMarketplaceArea = (state) => {
  const { marketplace: { layersNavigation: { area } } } = state
  const isKurchatov        = window && window.location && window.location.host === 'kurchatov.rosatom.city'
  if (isKurchatov) {
    return 'kurchatov'
  }
  const { areas } = marketplaceData
  // const isZv = window && window.location && window.location.host === 'smart-fe26.ru'
  //
  // if (isZv) {
  //   return 'zv'
  // }

  return Object.keys(areas).find((areaName) => areas[areaName] === area)
}


export default getMarketplaceArea
